<div class="stop-container">
  <img class="stop-img" src="assets/hex/hex-stop.png" />
</div>